<div class="tab-container">
  <div class="conn-toolbar">
    <div class="conn-seg" role="tablist">
      <button
        *ngFor="let tab of tabs; let i = index"
        type="button"
        role="tab"
        class="conn-seg__btn"
        [class.conn-seg__btn--active]="tabIndex === i"
        [attr.aria-selected]="tabIndex === i"
        (click)="onTabChange({ index: i })"
      >
        {{ tab.label }}
      </button>
    </div>
    <div class="conn-toolbar__actions">
      <button
        *ngIf="currentTabType === 'LLM' || currentTabType === 'LLM_PARSER' || (currentTabType === 'FILE' && isAgentic)"
        class="btn-accello-secondary setup-connection-btn"
        (click)="setupConnection(tabs[tabIndex]?.type, tabs[tabIndex].label)"
      >
        <span class="setup-connection-icon">
          <img
            class="setup-connection-icon__default"
            [src]="'images/virtusa-icons/setup-connection-light.svg' | assetUrl"
            alt="Setup Icon"
            width="18"
            height="18"
          />
          <img
            class="setup-connection-icon__hover"
            [src]="'images/virtusa-icons/setup-connection-dark.svg' | assetUrl"
            alt=""
            width="18"
            height="18"
          />
        </span>
        Configure Connection
      </button>
      <button
        *ngIf="canAddConnection"
        class="btn-accello-primary-light"
        (click)="addConnection(false)"
      >
        
        {{ buttonTitle }}
      </button>
    </div>
  </div>

  <div class="top-div">
    <div
      class="col-md-12 rounded d-flex flex-column overflow-auto custom-div"
    >
      <div
        class="row g-3"
        *ngIf="
          tabs[tabIndex]?.connections?.length && !isLoading;
          else noDataTemplate
        "
      >
        <div *ngFor="let section of providerSectionsList" class="mb-3">
          <div
            (click)="section.expanded = !section.expanded"
            class="cursor-pointer d-flex align-items-center mb-2"
            (keydown.enter)="section.expanded = !section.expanded"
          >
            <i
              class="bi mx-2"
              [class.bi-chevron-down]="section.expanded"
              [class.bi-chevron-right]="!section.expanded"
            ></i>
            <span class="header-12">{{ section.label }}</span>
          </div>

          <div *ngIf="section.expanded" class="ml-2 gap-3 conn-content">
            @for (conn of pagedConnections; track conn.connectionName) { @if
            (section.key === conn?.meta?.source) {
            <app-connection-card
              [connection]="conn"
              [isTesting]="isTesting && clickedConnection?.connectionName === conn.connectionName"
              [showTest]="conn?.connectionType != 'FILE'"
              [showEdit]="section.label !== 'Local' && !isOrgAlmLocked"
              [showDelete]="!isOrgAlmLocked"
              (test)="testConnection($event, conn)"
              (edit)="onConnectionEditClick($event, conn)"
              (delete)="deleteConnecetionConfirmation($event, conn)"
              (nameClick)="onConnectionExpand(conn)"
            ></app-connection-card>
            } }
          </div>
        </div>
      </div>

      <div
        class="h-100 d-flex justify-content-center align-items-center"
        *ngIf="isLoading"
      >
        <app-loading [text]="'Loading...'"></app-loading>
      </div>

      <ng-template #noDataTemplate>
        <app-no-data *ngIf="!isLoading" class="no-data"></app-no-data>
      </ng-template>
    </div>
  </div>
</div>
